import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ApiPortalRedirectProps {
  to: string;
}

/**
 * Custom redirect component that preserves URL hash/anchor fragments
 * when redirecting to a new path.
 * @param props - The component props
 * @param props.to - The path to redirect to
 */
export const ApiPortalRedirect: FC<ApiPortalRedirectProps> = ({ to }) => {
  const location = useLocation();

  // Preserve the hash/anchor from the original URL
  const redirectTo = `${to}${location.hash}`;

  return <Navigate to={redirectTo} replace />;
};
